import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import numeral from 'numeral';
import moment from 'moment';

import { useTheme } from '@material-ui/core/styles';

import {
  makeRowColumn,
  getHeadObj,
  dataConverter,
  converParameters,
  converDisplayValue,
  conversionParams,
  getHost,
  commonGetParams,
} from 'lib/commonLib';
import { setPortal } from 'modules/portal';
import { userOnLogin } from 'lib/api/user';
import { advertiserStatistics } from 'lib/api/report';
import { showSuccessSnackbar } from 'modules/snackbar';
import { paramConverter } from 'modules/common';

import MbButton from 'components/atoms/MbButton';
import MbTooltip from 'components/atoms/MbTooltip';
import CurrentStatus from 'components/atoms/CurrentStatus';
import NewButton from 'components/molecules/NewButton';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import VariousCell from 'components/molecules/MbTable/VariousCell';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import SortLabelWrap from 'components/molecules/MbTable/SortLabelWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

import StatisticsGraph from './StatisticsGraph';
// import StatisticsTable from './StatisticsTable';
// import StatisticsTopRnkTable from './StatisticsTopRnkTable';

const Statistics = (props) => {
  const { location, rtbDayPlatformList } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { common, portal, allProductCodeList } = useSelector(
    ({ common, portal }) => ({
      portal: portal,
      common: common,
      allProductCodeList: common.allProductCodeList,
    })
  );
  //키워드통계 - 지출금액 (adverIds)
  //통계보고서 - 일자별통계 - 일자별통계 :  advrtsPrdtCode, advrtsTpCode, pltfomTpCode, itlTpCode, sDate, eDate
  //통계보고서 - 일자별통계 - 카테고리통계 : advrtsTpCode, pltfomTpCode, itlTpCode, sDate, eDate

  const convertKeys = [
    'advrtsPrdtCode',
    'advrtsTpCode',
    'pltfomTpCode',
    'itlTpCode',
    'sDate',
    'eDate',
    'adverId',
    'adverIds',
    'contact',
    'trackerFlag',
    'tkgTpCode',
    'mediaScriptNo',
    'myFlag',
    'rankType',
    'uri',
    'isPop',
  ];

  let initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    pltfomTpCode: 'all',
    contact: 'all',
    prdtFlag: 'all',
    itlTpCode: '01,03,04,05,08,09,10,12,13,14,98,99',
    trackerFlag: 'all',
    tkgTpCode: 'all',
  };

  let initCustomized = {
    FIXED: { merged: true },
    ADVRTS_RNK: {
      makeHead: (headsMap) => {
        return (
          <>
            {t('지출금액')}
            <br />
            {t('등급')}
          </>
        );
      },
    },
    ADVER_NAME: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ADVER_NAME');
        let result = '';
        if (!!rowObj['PLTFOM_TP_CODE']) {
          result =
            rowObj['PLTFOM_TP_CODE'] === '01'
              ? t('웹')
              : rowObj['PLTFOM_TP_CODE'] === '02' && t('모바일');
        } else {
          result = makeRowColumn(
            rowObj['ADVER_NAME'],
            bodyItem1.type,
            bodyItem1.format
          );
        }
        return result;
      },
    },
    ADVER_ID: {
      makeBody: (rowObj, headsMap) => {
        let result = '';
        if (rowObj['FIXED'] !== 0) {
          result = rowObj['ADVER_ID'];
        }
        return result;
      },
    },
    KPI_GOAL_RATE: { merged: true },
    PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'PAR_EPRS_CNT').label}
            <br />
            {getHeadObj(headsMap, 'UNIQ_AUID_CNT').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'PAR_EPRS_CNT');
        const bodyItem2 = getHeadObj(headsMap, 'UNIQ_AUID_CNT');

        let result = (
          <>
            {makeRowColumn(
              rowObj['PAR_EPRS_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            {makeRowColumn(
              rowObj['UNIQ_AUID_CNT'],
              bodyItem2.type,
              bodyItem2.format
            )}
          </>
        );
        return result;
      },
      orderFlag: false,
    },
    UNIQ_AUID_CNT: { merged: true },
    M_PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return '';
      },
      makeBody: (rowObj, headsMap) => {
        let result = '';
        if (
          Number(rowObj['M_PAR_EPRS_CNT']) > '0' &&
          rowObj['FIXED'] !== 0 &&
          typeof rowObj['isChild'] === 'undefined'
        ) {
          result = (
            <NewButton
              iconBtn
              icon="faMobile"
              disableRipple
              onClick={(f) => f}
              disabled
            />
          );
        }
        return result;
      },
      bodyStyle: { padding: '0 5px' },
    },
    HOME_URL: { merged: true },
    KPI: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'KPI');
        const hasKpi = !!rowObj['KPI'] && rowObj['KPI'] !== '0';
        return (
          hasKpi && (
            <MbTooltip
              title={makeRowColumn(
                rowObj['KPI'],
                bodyItem1.type,
                bodyItem1.format
              )}
            >
              {makeRowColumn(rowObj['KPI'], bodyItem1.type, bodyItem1.format)}
            </MbTooltip>
          )
        );
      },
    },
    POINT: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'POINT');
        return (
          !rowObj['isChild'] &&
          makeRowColumn(rowObj['POINT'], bodyItem1.type, bodyItem1.format)
        );
      },
    },
    CONV_RATE: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'CONV_RATE').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CONV_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['CONV_RATE'],
              bodyItem1.type,
              bodyItem1.format
            )}
          </>
        );
      },
    },
    CONV_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'CONV_AMT').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CONV_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['CONV_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
          </>
        );
      },
    },
  };

  let newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  if (!!newInitParams['isPop']) {
    delete newInitParams['isPop'];
    newInitParams['table'] = 'popup';
  }
  initParams = { ...initParams, ...newInitParams };
  const locationSearch = queryString.parse(location.search);
  const isPopPage = initParams.table === 'popup';
  const [popupFlag, setPopupFlag] = useState(!isPopPage);
  const [isRtbPage, setIsRtbPage] = useState(false);
  const borderRangeStart = isPopPage ? 14 : 17;
  const borderRangeEnd = isPopPage ? 18 : 22;
  const topRankList = [
    { label: t('1등급'), value: '1' },
    { label: t('2등급'), value: '2' },
    { label: t('3등급'), value: '3' },
    { label: t('4등급'), value: '4' },
    { label: t('5등급'), value: '5' },
    { label: t('6등급'), value: '6' },
    { label: t('7등급'), value: '7' },
    { label: t('8등급'), value: '8' },
    { label: t('9등급'), value: '9' },
    { label: t('10등급'), value: '10' },
    { label: t('11등급'), value: '11' },
    { label: t('12등급'), value: '12' },
    { label: t('13등급'), value: '13' },
    { label: t('14등급'), value: '14' },
    { label: t('15등급'), value: '15' },
    { label: t('16등급'), value: '16' },
  ];

  if (isPopPage) {
    initCustomized = {
      ...initCustomized,
      TRGT_ECPM: { merged: true },
    };
  }

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);
  const [customized, setCustomized] = useState(initCustomized);

  const rtbCustomized = {
    BID_REQ_CNT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'BID_REQ_CNT').label}
            <br />
            {getHeadObj(headsMap, 'BID_CNT').label}
            <br />
            {getHeadObj(headsMap, 'BID_RATE').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'BID_REQ_CNT');
        const bodyItem2 = getHeadObj(headsMap, 'BID_CNT');
        const bodyItem3 = getHeadObj(headsMap, 'BID_RATE');
        return (
          <>
            {makeRowColumn(
              rowObj['BID_REQ_CNT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            {makeRowColumn(rowObj['BID_CNT'], bodyItem2.type, bodyItem2.format)}
            <br />
            {makeRowColumn(
              rowObj['BID_RATE'],
              bodyItem3.type,
              bodyItem3.format
            )}
          </>
        );
      },
    },
    BID_CNT: { merged: true, orderFlag: false },
    BID_RATE: { merged: true, orderFlag: false },
    BID_ECPM: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'BID_ECPM').label}
            <br />
            {getHeadObj(headsMap, 'WIN_BID_ECPM').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'BID_ECPM');
        const bodyItem2 = getHeadObj(headsMap, 'WIN_BID_ECPM');
        return (
          <>
            {makeRowColumn(
              rowObj['BID_ECPM'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            {makeRowColumn(
              rowObj['WIN_BID_ECPM'],
              bodyItem2.type,
              bodyItem2.format
            )}
          </>
        );
      },
      orderFlag: false,
    },
    WIN_BID_ECPM: { merged: true },
    ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return (
            <>
              {getHeadObj(headsMap, 'ADVRTS_AMT').label}
              <br />
              {getHeadObj(headsMap, 'KAKAO_BDGT_AMT_LIMIT').label}
            </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ADVRTS_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'KAKAO_BDGT_AMT_LIMIT');
        return (
            <>
              {makeRowColumn(
                  rowObj['ADVRTS_AMT'],
                  bodyItem1.type,
                  bodyItem1.format
              )}
              <br />
              <span style={{ color: theme.palette.common.black }}>
              {makeRowColumn(
                  rowObj['KAKAO_BDGT_AMT_LIMIT'],
                  bodyItem2.type,
                  bodyItem2.format
              )}
              </span>
            </>
        );
      },
    },
    KAKAO_BDGT_AMT_LIMIT: { merged: true },
    MEDIA_PYMNT_AMT: {
      makeHead: (headsMap) => {
        return (
            <>
              {getHeadObj(headsMap, 'MEDIA_PYMNT_AMT').label}
            </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        return (
            <>
            <span style={{ color: theme.palette.common.red }}>
            {makeRowColumn(
                rowObj['MEDIA_PYMNT_AMT'],
                getHeadObj(headsMap, 'MEDIA_PYMNT_AMT').type,
                getHeadObj(headsMap, 'MEDIA_PYMNT_AMT').format
            )}
            </span>
            </>
        );
      },
    },
  };

  useEffect(() => {
    if (isPopPage) {
      setPopupFlag(false);
    } else {
      handleCustom(initParams);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (isPopPage) {
      if (common.productCodeList.size > 0) {
        if (Object.keys(locationSearch).length > 0) {
          let newParams = {};
          const converParams = conversionParams(
            common.productCodeList,
            locationSearch,
            allProductCodeList
          );
          // eslint-disable-next-line
          newParams = { ...initParams, ...converParams };
          if (!!converParams.contactNo) {
            delete newParams['contactUserId'];
          }
          if (
            converParams.baseAddress === '/v2/rtb_report/rtb_day_report.php'
          ) {
            // openRTB통계 - 카카오RTB - 일자별통계
            newParams['table'] = 'kakao_popup';
            newParams['itlTpCode'] = '03';
            newParams['limit'] = '100';
            setIsRtbPage(true);
          } else if (
            converParams.baseAddress === '/v2/media_report/ajax/ajaxBulkMediaMc.php' || converParams.baseAddress === '/v2/media_report/manage_report_media_new.php'
          ) {
            delete newParams['mediaId'];
          } else if (
            converParams.baseAddress ===
            '/v2/openrtb/manage_openrtb_day_report.php'
          ) {
            newParams['table'] = 'kakao_popup';
            delete newParams['tp_code'];
            setIsRtbPage(true);
          } else if (
            converParams.baseAddress ===
            '/v2/openrtb/manage_media_detail_popup_new.php'
          ) {
            delete newParams['mc'];
          }
          setParams(newParams);
          setTempParams(newParams);
          setPopupFlag(true);
          handleCustom(newParams);
        }
      }
    }
    // eslint-disable-next-line
  }, [common.productCodeList]);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const handleOnReset = () => {
    if (
      JSON.stringify(params) !== JSON.stringify(initParams) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParams)
    ) {
      setInitialization(true);
      setParams(initParams);
      setTempParams(initParams);
      handleCustom(initParams);
    }
  };

  const getParam = () => {
    if (JSON.stringify(params) !== JSON.stringify(tempParams)) {
      setParams(tempParams);
      handleCustom(tempParams);
    }
  };
  const getTempParam = (newParams) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  const handleGetParam = (newParams, name) => {
    // 테이블에서 사용하는 별도 함수
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      const result = commonGetParams(params, newParams, name);
      setParams(result);
      setTempParams(result);
      handleCustom(result);
    }
  };

  const handleTableKey = (name) => {
    let newParams = { ...tempParams };
    if (!!newParams[name]) {
      delete newParams[name];
    } else {
      const newValue = name === 'table' ? 'duple' : '01';
      newParams = { ...newParams, [name]: newValue };
    }
    setTempParams(newParams);
  };

  const handleSortChange = (propsParams, orderKey) => {
    const { order, sort } = propsParams;
    let newParams = { ...propsParams };
    const isDesc = order === orderKey && sort === 'desc';
    const converSort = isDesc ? 'asc' : 'desc';
    newParams = { ...newParams, order: orderKey, sort: converSort };
    setParams(newParams);
    setTempParams(newParams);
    handleCustom(newParams);
  };

  const handleCustom = (propsParams = params) => {
    let newCustomized = { ...initCustomized };
    newCustomized = {
      ...newCustomized,
      SITE_NAME: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'SITE_NAME');
          let resultComponent;
          const showWindowUrl = converParameters({
            url: getHost() + '/v2/popup/manage_report_media_day_mc.php',
            gb: converDisplayValue(
              common.productCodeList,
              propsParams['advrtsPrdtCode'],
              propsParams['advrtsTpCode']
            ),
            st_date: moment(propsParams['sDate']).format('YYYY-MM-DD'),
            en_date: moment(propsParams['eDate']).format('YYYY-MM-DD'),
            mcode: rowObj['ADVER_ID'],
            gb_web: Number(propsParams['pltfomTpCode']),
          });
          const showWindowUrl2 = converParameters({
            url: getHost() + '/v2/popup/manage_report_media_day_mc_mcode.php',
            gb: converDisplayValue(
              common.productCodeList,
              propsParams['advrtsPrdtCode'],
              propsParams['advrtsTpCode']
            ),
            st_date: moment(propsParams['sDate']).format('YYYY-MM-DD'),
            en_date: moment(propsParams['eDate']).format('YYYY-MM-DD'),
            gb_web: Number(propsParams['pltfomTpCode']),
            mc: propsParams['mediaScriptNo'],
            mcode: rowObj['ADVER_ID'],
          });

          const subTitle = rowObj['PLTFOM_TP_CODE'];

          if (rowObj['FIXED'] === 0) {
            resultComponent = (
              <>
                {makeRowColumn(
                  rowObj['SITE_NAME'],
                  bodyItem1.type,
                  bodyItem1.format
                )}{' '}
                ({numeral(rowObj['ADVER_ID']).format()})
              </>
            );
          } else if (subTitle === '01' || subTitle === '02') {
            let tempCode;
            if (subTitle === '01') {
              tempCode = '웹';
            } else if (subTitle === '02') {
              tempCode = '모바일';
            }
            resultComponent = <>{tempCode}</>;
          } else if (rowObj['ADVER_ID'] !== '') {
            resultComponent = (
              <IconAreaWrap text={rowObj['SITE_NAME']}>
                <NewButton
                  title={t('사이트로 이동')}
                  iconBtn
                  icon="faHome"
                  disableRipple
                  onClick={(e) =>
                    handlePortalUrl('https://' + rowObj['HOME_URL'])
                  }
                />
                <MbTooltip
                  title={t('해당 광고주의 상세 통계')}
                  onClick={(e) => handlePortalUrl(showWindowUrl)}
                >
                  <MbButton iconBtn icon="faExternalLink" />
                </MbTooltip>
                <MbTooltip
                  title={t('해당 광고주의 상세 통계(쇼핑)')}
                  onClick={(e) => handlePortalUrl(showWindowUrl2)}
                >
                  <MbButton iconBtn icon="faExternalLink" />
                </MbTooltip>
                <MbTooltip title={t('광고주 로그인')}>
                  <MbButton
                    iconBtn
                    icon="faSignInAlt"
                    onClick={(e) => handleOnLogin(rowObj['ADVER_ID'])}
                  />
                </MbTooltip>
              </IconAreaWrap>
            );
          } else {
            resultComponent = t('광고주 ID 없음.');
          }
          return resultComponent;
        },
      },
      M_PAR_EPRS_CNT: {
        makeHead: (headsMap) => {
          return t('관리');
        },
        makeBody: (rowObj, headsMap) => {
          let result = '';
          let newMcgb = '';

          const addKakaoFlag =
            propsParams.baseAddress === '/v2/rtb_report/rtb_day_report.php';
          const isRtbDayPage =
            propsParams.baseAddress ===
            '/v2/openrtb/manage_openrtb_day_report.php';

          if (addKakaoFlag || isRtbDayPage) {
            newMcgb = 'R';
          }

          const showWindowUrl = converParameters({
            url: getHost() + '/v2/popup/manage_report_media_day_mc_mcode.php',
            gb: converDisplayValue(
              common.productCodeList,
              propsParams['advrtsPrdtCode'],
              propsParams['advrtsTpCode']
            ),
            st_date: moment(propsParams['sDate']).format('YYYY-MM-DD'),
            en_date: moment(propsParams['eDate']).format('YYYY-MM-DD'),
            mcode: rowObj['ADVER_ID'],
            mcgb: newMcgb,
            mc: propsParams['mediaScriptNo'],
            rtb_tp_code: addKakaoFlag ? '01' : '',
            ITL_TP_CODE: isRtbDayPage ? propsParams['itlTpCode'] : '',
          });
          if (
            rowObj['FIXED'] !== 0 &&
            typeof rowObj['isChild'] === 'undefined'
          ) {
            result = (
              <TableBtnWrap>
                <NewButton
                  title={t('사이트로 이동')}
                  iconBtn
                  icon="faHome"
                  disableRipple
                  onClick={() =>
                    window.open('https://' + rowObj['HOME_URL'], '_blank')
                  }
                />
                <NewButton
                  title={t('해당 광고주의 일자별 통계')}
                  iconBtn
                  icon="faExternalLink"
                  disableRipple
                  onClick={(e) => handlePortalUrl(showWindowUrl)}
                />
              </TableBtnWrap>
            );
          }
          return result;
        },
        bodyStyle: { padding: '0 5px' },
      },
      SESSION_CONV_CNT: {
        makeHead: (headsMap) => {
          let result = '';
          if (propsParams.table === 'duple') {
            result = (
              <>
                {getHeadObj(headsMap, 'SESSION_CONV_CNT').label}
              </>
            );
          } else {
            result = getHeadObj(headsMap, 'SESSION_CONV_CNT').label;
          }
          return result;
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'SESSION_CONV_CNT');
          const showWindowUrl = converParameters({
            url: getHost() + '/v2/popup/daily_conversion.php',
            gb: converDisplayValue(
              common.productCodeList,
              propsParams['advrtsPrdtCode'],
              propsParams['advrtsTpCode']
            ),
            gb_web: Number(propsParams['pltfomTpCode']),
            st_date: moment(propsParams['sDate']).format('YYYY-MM-DD'),
            en_date: moment(propsParams['eDate']).format('YYYY-MM-DD'),
            mcode: rowObj['ADVER_ID'],
          });

          return isPopPage ||
            (rowObj['SITE_NAME'] === undefined && rowObj['isChild'] === 1) ? (
            makeRowColumn(rowObj['SESSION_CONV_CNT'], bodyItem1.type, bodyItem1.format)
          ) : (
            <IconAreaWrap
              text={
                makeRowColumn(
                  rowObj['SESSION_CONV_CNT'],
                  bodyItem1.type,
                  bodyItem1.format
                )
              }
              icon="faExternalLink"
              toolTipTitle={t('해당 광고주의 컨버전내역 팝업')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          );
        },
      },
      KPI_STR: {
        makeHead: (headsMap) => {
          return (
            <>
              KPI
              {propsParams.baseAddress !==
                '/time/manage_report_media_time.php' && (
                <>
                  <br />
                  {getHeadObj(headsMap, 'KPI_GOAL_RATE').label}
                </>
              )}
            </>
          );
        },
        makeBody: (rowObj, headsMap) => {
          // const bodyItem1 = getHeadObj(headsMap, 'KPI_STR');
          const bodyItem2 = getHeadObj(headsMap, 'KPI_GOAL_RATE');
          const regex = /[^0-9]/g;
          let newKpiStr = rowObj['KPI_STR'];
          let kpiStrText = '';
          let unit = '';
          if (!!rowObj['KPI_STR']) {
            newKpiStr = newKpiStr.replace(regex, '');
            kpiStrText = rowObj['KPI_STR'].split(' ')[0];
            unit = rowObj['KPI_STR'].substr(-1);
          }
          return (
            rowObj['FIXED'] !== 0 &&
            typeof rowObj['isChild'] === 'undefined' && (
              <>
                {kpiStrText} {makeRowColumn(newKpiStr, 'number', '#,##0')}
                {unit}
                {propsParams.baseAddress !==
                  '/time/manage_report_media_time.php' && (
                  <>
                    <br />
                    <span style={
                      rowObj['KPI_GOAL_RATE'] >= 1
                          ? { color: theme.palette.common.blue }
                          : { color: theme.palette.common.red }
                    }>
                    {makeRowColumn(
                      rowObj['KPI_GOAL_RATE'],
                      bodyItem2.type,
                      bodyItem2.format
                    )}
                    </span>
                  </>
                )}
              </>
            )
          );
        },
      },
    };
    if (isPopPage) {
      const customizedList = {
        // 결제매출
        MOB_SESSION_ROAS: [
          'MOB_SESSION_ROAS',
          'TRGT_MOB_SESSION_ROAS',
          'MOB_SESSION_ORDER_AMT',
        ],
        // 브라우져 세션매출
        BROWSER_SESSION_ROAS: [
          'BROWSER_SESSION_ROAS',
          'TRGT_BROWSER_SESSION_ROAS',
          'BROWSER_SESSION_ORDER_AMT',
        ],
        // 세션매출
        SESSION_ROAS: [
          'SESSION_ROAS',
          'TRGT_SESSION_ROAS',
          'SESSION_ORDER_AMT',
        ],
        // 직접매출
        DIRECT_ROAS: ['DIRECT_ROAS', 'TRGT_DIRECT_ROAS', 'DIRECT_ORDER_AMT'],
        // 총매출
        ROAS: ['ROAS', 'TRGT_ROAS', 'ORDER_AMT'],
      };
      for (let target in customizedList) {
        const targetKey = customizedList[target];
        newCustomized[targetKey[0]] = {
          makeHead: (headsMap) => {
            const toolTiptext = '테이블쇼핑툴팁' + targetKey[2];
            return {
              content: (
                <InfoTitleArea
                  title={t('테이블쇼핑타이틀', {
                    label: getHeadObj(headsMap, targetKey[2]).label,
                  })}
                  tooltipTitle={t(toolTiptext)}
                  iconType="fainfoCircle"
                />
              ),
            };
          },
          makeBody: (rowObj, headsMap) => {
            const bodyItem1 = getHeadObj(headsMap, targetKey[0]);
            const bodyItem2 = getHeadObj(headsMap, targetKey[1]);
            const bodyItem3 = getHeadObj(headsMap, targetKey[2]);
            return (
              <VariousCell
                type="TRGT"
                bold
                item1={makeRowColumn(
                  rowObj[targetKey[0]],
                  bodyItem1.type,
                  bodyItem1.format
                )}
                item2={makeRowColumn(
                  rowObj[targetKey[1]],
                  bodyItem2.type,
                  bodyItem2.format
                )}
                item3={makeRowColumn(
                  rowObj[targetKey[2]],
                  bodyItem3.type,
                  bodyItem3.format
                )}
              />
            );
          },
        };
        newCustomized[targetKey[1]] = { merged: true };
        newCustomized[targetKey[2]] = { merged: true };
      }
      newCustomized['ECPM'] = {
        makeHead: (headsMap) => {
          return (
            <SortLabelWrap
              params={propsParams}
              label={
                <InfoTitleArea
                  title={t('테이블쇼핑타이틀', {
                    label: getHeadObj(headsMap, 'ECPM').label,
                  })}
                  tooltipTitle={t('테이블쇼핑툴팁ECPM')}
                  iconType="fainfoCircle"
                />
              }
              orderKey="ECPM"
              onClick={(e) => handleSortChange(propsParams, 'ECPM')}
            />
          );
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'ECPM');
          const bodyItem2 = getHeadObj(headsMap, 'TRGT_ECPM');
          return (
            <>
              {makeRowColumn(rowObj['ECPM'], bodyItem1.type, bodyItem1.format)}
              <br />(
              {makeRowColumn(
                rowObj['TRGT_ECPM'],
                bodyItem2.type,
                bodyItem2.format
              )}
              )
            </>
          );
        },
        orderFlag: false,
      };
      newCustomized['PAR_EPRS_CNT'] = {
        makeHead: (headsMap) => {
          return getHeadObj(headsMap, 'PAR_EPRS_CNT').label;
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'PAR_EPRS_CNT');
          return makeRowColumn(
            rowObj['PAR_EPRS_CNT'],
            bodyItem1.type,
            bodyItem1.format
          );
        },
        orderFlag: true,
      };
    } else {
      const customizedList = [
        'BROWSER_SESSION_ROAS',
        'SESSION_ROAS',
        'DIRECT_ROAS',
        'ROAS',
      ];
      for (let target of customizedList) {
        newCustomized[target] = {
          makeBody: (rowObj, headsMap) => {
            const bodyItem1 = getHeadObj(headsMap, target);
            const bodyItem2 = getHeadObj(headsMap, 'MOB_' + target);
            return (
              <>
                {makeRowColumn(
                  rowObj[target],
                  bodyItem1.type,
                  bodyItem1.format
                )}
                <br />
                <span style={{ color: theme.palette.common.red }}>
                  (
                  {makeRowColumn(
                    rowObj['MOB_' + target],
                    bodyItem2.type,
                    bodyItem2.format
                  )}
                  )
                </span>
              </>
            );
          },
        };
        newCustomized['MOB_' + target] = { merged: true };
      }
    }

    if (propsParams['table'] === 'duple') {
      const dupleList = ['', 'DUPLE_', 'UNIQ_'];
      for (let target of dupleList) {
        newCustomized[target + 'CLICK_CNT'] = {
          makeHead: (headsMap) => {
            return (
              <>
                {getHeadObj(headsMap, target + 'CLICK_CNT').label}(%)
                <br />
                {getHeadObj(headsMap, target + 'TOT_CLICK_CNT').label}(%)
              </>
            );
          },
          makeBody: (rowObj, headsMap) => {
            const bodyItem1 = getHeadObj(headsMap, target + 'CLICK_CNT');
            const bodyItem2 = getHeadObj(headsMap, target + 'CLICK_RATE');
            const bodyItem3 = getHeadObj(headsMap, target + 'TOT_CLICK_CNT');
            const bodyItem4 = getHeadObj(headsMap, target + 'TOT_CLICK_RATE');
            return (
              <>
                {makeRowColumn(
                  rowObj[target + 'CLICK_CNT'],
                  bodyItem1.type,
                  bodyItem1.format
                )}
                (
                {makeRowColumn(
                  rowObj[target + 'CLICK_RATE'],
                  bodyItem2.type,
                  bodyItem2.format
                )}
                )
                <br />
                {makeRowColumn(
                  rowObj[target + 'TOT_CLICK_CNT'],
                  bodyItem3.type,
                  bodyItem3.format
                )}
                (
                {makeRowColumn(
                  rowObj[target + 'TOT_CLICK_RATE'],
                  bodyItem4.type,
                  bodyItem4.format
                )}
                )
              </>
            );
          },
        };
        newCustomized[target + 'CLICK_RATE'] = { merged: true };
        newCustomized[target + 'TOT_CLICK_CNT'] = { merged: true };
        newCustomized[target + 'TOT_CLICK_RATE'] = { merged: true };
      }
    }
    setCustomized(newCustomized);
  };

  /**
   * 로그인처리
   */
  const handleOnLogin = (ADVER_ID) => {
    userOnLogin(ADVER_ID, 'manage')
      .then((response) => {
        const { data, success } = response.data;
        if (success) {
          handlePortalUrl(data.url);
        } else {
          handleClickSnackbar({
            message: t('로그인에 실패했습니다. 관리자에게 문의하세요.'),
            option: { type: 'error' },
          });
        }
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      });
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return popupFlag ? (
    <>
      <NewFilterWrap handleOnReset={isPopPage ? undefined : handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={tempParams}
          getParam={getTempParam}
          useManagerFilter={true}
          pltfomTpCodeDetailFilter={isPopPage && ['03', '04']}
          useTracker
          useTkgTpCode
          useTimeFilter={
            params.statsHh !== undefined
          }
          usePltfomTpCodeFilter={
            params.baseAddress !== '/v2/rtb_report/rtb_day_report.php'
          }
          externalType={
            params['table'] === 'kakao_popup' ? 'select' : 'checkbox'
          }
        >
          {params.baseAddress === '/v2/rtb_report/rtb_day_report.php' && (
            <FilterCollection
              label={t('유형 구분')}
              name="pltfomTpCode"
              params={tempParams}
              value={tempParams.pltfomTpCode}
              type="radio"
              list={rtbDayPlatformList}
              callBack={getTempParam}
              labelKey="label"
              valueKey="value"
            />
          )}
        </NewCommonFilter>

        {isPopPage === false && (
          <>
            <FilterCollection
              label={t('상품구분')}
              name="prdtFlag"
              params={tempParams}
              value={tempParams.prdtFlag}
              type="radio"
              list={[
                { label: t('전체'), value: 'all' },
                { label: t('쇼핑'), value: '01' },
                { label: t('비쇼핑'), value: '02' },
              ]}
              callBack={getTempParam}
              labelKey="label"
              valueKey="value"
            />
            <NewButton
              type="filterButton"
              onClick={() => handleTableKey('table')}
              style={
                !!tempParams.table
                  ? { backgroundColor: '#79bd2f', color: '#fff' }
                  : {}
              }
              disableRipple
            >
              {t('중복클릭보기')}
            </NewButton>
            <FilterCollection
              label={t('등급')}
              name="topRank"
              params={tempParams}
              value={tempParams.topRank}
              type="checkbox"
              list={topRankList}
              callBack={getTempParam}
              labelKey="label"
              valueKey="value"
              popoverMaxWidth={640}
              popoverHeight={420}
            />
          </>
        )}
        <NewButton
          type="filterButton"
          onClick={() => handleTableKey('myFlag')}
          style={
            !!tempParams.myFlag
              ? { backgroundColor: '#79bd2f', color: '#fff' }
              : {}
          }
          disableRipple
        >
          {t('내 광고주보기')}
        </NewButton>
        <NewButton type="filterButton" onClick={getParam} disableRipple>
          {t('검색')}
        </NewButton>
      </NewFilterWrap>
      {isPopPage === false && (
        <StatisticsGraph handleClickSnackbar={handleClickSnackbar} />
      )}
{/*      {isPopPage === false && (
        <StatisticsTable
          handleClickSnackbar={handleClickSnackbar}
          params={paramConverter({
            statsMth: moment()
              .add(-1, 'month')
              .startOf('month')
              .format('YYYYMM'),
            table: 'board',
            prdtFlag: params.prdtFlag,
          })}
          handlePortalUrl={handlePortalUrl}
        />
      )}
      {isPopPage === false && (
        <StatisticsTopRnkTable
          handleClickSnackbar={handleClickSnackbar}
          params={paramConverter({
            statsMth: moment()
              .add(-1, 'month')
              .startOf('month')
              .format('YYYYMM'),
            table: 'board',
            prdtFlag: params.prdtFlag,
          })}
        />
      )}*/}
      <NewTableContainer
        params={params}
        getParam={handleGetParam}
        dataReqPromise={advertiserStatistics}
        customized={
          isRtbPage ? { ...customized, ...rtbCustomized } : customized
        }
        expandTable
        useFetch={false}
        isIncludingTotal
        useTotalSubList
        reFetchHead
        excelItemsRemoval="M_PAR_EPRS_CNT,HOME_URL,KPI"
        rowsPerPage={50}
        useSearch={!isPopPage}
        totalExcludeKey={['KPI_STR', 'KPI_GOAL_RATE']}
        borderRangeStart={borderRangeStart}
        borderRangeEnd={borderRangeEnd}
      />
    </>
  ) : (
    <CurrentStatus type="loading" option="useMinHeight" />
  );
};

export default withRouter(Statistics);
